import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=29094ec0"
import script from "./NotificationsButton.vue?vue&type=script&lang=js"
export * from "./NotificationsButton.vue?vue&type=script&lang=js"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=29094ec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports